import fetch from '@app-src/data/api/fetch-from-accounts-api'
import { fetchData } from '@purecarslabs/signal-core/swr/fetch'
/* webpack-strip-block:removed */

/**
 * lookupAccountId
 * @description looks up an account id given a dealer id
 * @param {Number} dealerId - the legacy dealer id
 * @return {String} - the accountId from the endpoint
 */
const lookupAccountId = async (dealerId: number): Promise<string | null> =>
  /* webpack-strip-block:removed */
      fetchData({
        fetcher: fetch({ fetchContext: 'Lookup AccountId' }),
        noContentResponse: null,
        url: `v1/attributes/${dealerId}/to-guid`
      })

export default lookupAccountId
